define.alias("shared/utils/formatters/ig-hashtag-from-dynamo", "calendar/utils/formatters/ig-hashtag-from-dynamo");